// extracted by mini-css-extract-plugin
export default {"pageLink":"styles-module--page-link--1d214","currentPage":"styles-module--current-page--9d050"};